import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const wordpress = defineConnector({
  identifier: "wordpress",
  name: "WordPress",
  tagLine: "Website and blog platform",
  keywords: "wp cms blog blogging posts pages content management publishing",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://public-api\\.wordpress\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [WordPress.com Developer Resources](https://developer.wordpress.com/apps/) and create an application to get an access token.",
        },
      ],
    },
    {
      title: "Copy and paste the access token into the field below",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://public-api.wordpress.com/rest/v1.1/me",
  },
});
